export default "__VITE_ASSET__b1e00853__"